export default __webpack_public_path__ + "static/media/elevate-pyl-poster-1.f5258f9b.jpg";